import { ISorter, ISorterConfig, ISorterExpression, SorterConfig } from "pbc.types";

export interface IObjektNutzungSorter extends ISorter {
  id?: ISorterExpression;
  name?: ISorterExpression;
  beschreibung?: ISorterExpression;
}

export const ObjektNutzungSorterConfig: ISorterConfig = [
  SorterConfig('id', 'Id'),
  SorterConfig('name', 'Name'),
  SorterConfig('beschreibung', 'Beschreibung')
];
